import { render } from "./PagePartnerAdd.vue?vue&type=template&id=1e3fc076"
import script from "./PagePartnerAdd.vue?vue&type=script&lang=js"
export * from "./PagePartnerAdd.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__